import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link
  },
  layout: Layout,
  props: {},
  data: function data() {
    return {
      form: {
        start_date: null,
        end_date: null,
        tenant_id: null
      },
      date: [],
      dailyStat: [],
      showDailyStat: false,
      accountStat: [],
      selectedTenant: ""
    };
  },
  mounted: function mounted() {
    this.reset();
  },
  methods: {
    reset: function reset() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      var endDate = this.$helpers.changeDateFormat(end);
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
      var startDate = this.$helpers.changeDateFormat(start);
      this.form.start_date = startDate;
      this.form.end_date = endDate;
      this.form.tenant_id = null;
      this.date = [startDate, endDate];
      this.showAccountStatData();
    },
    dateChange: function dateChange(val) {
      if (val) {
        this.form.start_date = val[0];
        this.form.end_date = val[1];
        this.form.tenant_id = null;
        this.showAccountStatData();
      } else {
        this.form.start_date = null;
        this.form.end_date = null;
        this.form.tenant_id = null;
        this.showAccountStatData();
      }
    },
    dateDisabled: function dateDisabled(time) {
      var max = new Date();
      max.setTime(max.getTime() - 3600 * 1000 * 24 * 1);
      return time.getTime() > max;
    },
    showAccountStatData: function showAccountStatData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.loading = true;
                _context.next = 3;
                return axios.post('/data/get_account_stat', _this.form);
              case 3:
                res = _context.sent;
                _this.accountStat = res.data.account_stat_data;
                _this.$store.loading = false;
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    showDailyStatData: function showDailyStatData(row, column, index) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.loading = true;
                _this2.form.tenant_id = row.tenant_id;
                _this2.selectedTenant = row.tenant_id;
                _context2.next = 5;
                return axios.post('/data/account_daily_stat', _this2.form);
              case 5:
                res = _context2.sent;
                _this2.dailyStat = res.data.stat_data;
                _this2.form.tenant_id = null;
                _this2.showDailyStat = true;
                _this2.$store.loading = false;
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  computed: {
    shortcuts: function shortcuts() {
      var _this3 = this;
      return [{
        text: 'Last week',
        value: function value() {
          var end = new Date();
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
          return [_this3.$helpers.changeDateFormat(start), _this3.$helpers.changeDateFormat(end)];
        }
      }, {
        text: 'Last month',
        value: function value() {
          var end = new Date();
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
          return [_this3.$helpers.changeDateFormat(start), _this3.$helpers.changeDateFormat(end)];
        }
      }, {
        text: 'Last 3 months',
        value: function value() {
          var end = new Date();
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
          return [_this3.$helpers.changeDateFormat(start), _this3.$helpers.changeDateFormat(end)];
        }
      }];
    }
  }
};